module.exports = __webpack_public_path__ + "static/window-3c075802df22b1eb45c4f9f3836a33bf.mp4";